export class CreateMedicine{
    MedicineName: string=''
    IsActive: boolean
}

export class EditMedicine{
    id: any
    MedicineName: string=''
    IsActive: boolean
}